import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { forceRender } from './actions'

export function mapStateToProps(state, hocProps) {
    return {
        forceRenderFlag: state.getIn(['virtualList', hocProps.id, 'forceRenderFlag'], false),
    }
}

export function mapDispatchToProps(dispatch) {
    return bindActionCreators({ forceRender }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
